import React from 'react';
import { AccordionItem, WysiwygField } from '../../../components';

const FAQ = ({ entity }) => {
  const content = (
    <WysiwygField
      html={entity.getIn(['field_answer', 0, 'processed'], '')}
    />
  );

  return (
    <AccordionItem
      title={entity.getIn(['title', 0, 'value'])}
      content={content}
    />
  );
};

export default FAQ;
